import { all, call, put, takeEvery, select, SagaReturnType } from 'redux-saga/effects';
import {
    getAllUsersError,
    getAllUsersRequest,
    getAllUsersSuccess,
    getStudentsError,
    getStudentsRequest,
    getStudentsSuccess,
    getUserRequest,
    putUserToState,
    removeUserDownloading,
    setUserDownloading,
} from './index';
import { getAllUsers, getStudents, getUserById } from '../api/usersApi';
import { User } from '../types';
import { AxiosError, AxiosResponse } from 'axios';
import { PayloadAction } from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';
import { RootState } from '@shared/types';

export function* getUserSaga(action: PayloadAction<number>): SagaIterator {
    const userId = action.payload;

    const existingUser = yield select((state: RootState) => state.users.users.find((user) => user.pk === userId));

    const isUserLoading = yield select((state) => state.users.usersIdsDownloading.includes(userId));

    if (!existingUser && !isUserLoading) {
        try {
            yield put(setUserDownloading(userId));
            const response: { data: User } = yield call(getUserById, userId);
            yield put(putUserToState(response.data));
        } catch (error) {
            console.error('Failed to fetch user. Error: ', error);
        } finally {
            yield put(removeUserDownloading(userId));
        }
    }
}

export function* getAllUsersSaga(): SagaIterator {
    try {
        const response: AxiosResponse<User[]> = yield call(getAllUsers);
        yield put(getAllUsersSuccess(response.data));
    } catch (error) {
        yield put(getAllUsersError(error as AxiosError));
    }
}

type GetStudentsReturnType = SagaReturnType<typeof getAllUsers>;
export function* getStudentsSaga(): SagaIterator {
    try {
        const response: GetStudentsReturnType = yield call(getStudents);
        yield put(getStudentsSuccess(response.data));
    } catch (error) {
        yield put(getStudentsError(error as AxiosError));
    }
}

export default function* usersSagaWatcher() {
    yield all([
        takeEvery(getUserRequest.type, getUserSaga),
        takeEvery(getAllUsersRequest.type, getAllUsersSaga),
        takeEvery(getStudentsRequest.type, getStudentsSaga),
    ]);
}
